import InterposerImage from '../images/InterposerImage';
import Layer from './Layer';

const interposerLayer: Layer = {
  PlaneImage: InterposerImage,
  anchorPositionX: 0.88,
  anchorPositionY: 0.72,
  collapsedOffsetY: -0.185,
  description: `
    Leverages CMOS packaging techniques, including thru-substrate vias, to exploit the third
    dimension to electrically connect the qubits to the other planes and deliver the signals while
    protecting their coherence.
  `,
  name: 'Interposer',
  openOffsetY: -0.25,
  type: 'openable',
};

export default interposerLayer;
